<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",

  created() {
    // Store the current path before any redirects
    const currentPath = this.$route.path;
    // Check if there's a saved user in localStorage
    const savedUser = localStorage.getItem("user");
    const session = this.$cookies.get("session");

    if (session) {
      // console.log("session", session);
      const decodedToken = JSON.parse(atob(session.accessToken.split(".")[1]));
      const currentTime = Math.floor(new Date().getTime() / 1000);
      if (currentTime > decodedToken.exp) {
        console.log("session expired");
        this.$cookies.remove("session");
        localStorage.removeItem("user");
        this.$router.push("/login");
        return;
      }

      // If there's a saved user in localStorage with a role, use that user data
      if (savedUser) {
        const user = JSON.parse(savedUser);
        // Merge data from session (for token) and localStorage (for role)
        const mergedSession = {
          ...session,
          role: user.role || session.role,
        };
        this.$store.dispatch("login/setSession", mergedSession);
      } else {
        this.$store.dispatch("login/setSession", session);
      }

      // Only redirect to /main if we're at the root path
      if (currentPath === "/") {
        this.$router.push("/main");
      }
      // Otherwise, stay on the current path
    } else {
      if (
        currentPath !== "/activate" &&
        currentPath !== "/recover" &&
        currentPath !== "/reset" &&
        currentPath !== "/reactivate"
      ) {
        this.$router.push("/login");
      }
    }
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
  font-size: 1.2rem;
}
tbody tr.selected {
  /*color: #ffffff;*/
  font-weight: bold;
  /*background-color: #e4b9b9;*/
  color: #d73925;
}

tbody tr:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue